import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash, Buildings, GraduationCap, UsersThree, CalendarBlank } from "@phosphor-icons/react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const TYPES = [
  { key: "campus", label: "Campus", icon: Buildings },
  { key: "filiere", label: "Filières", icon: GraduationCap },
  { key: "promotion", label: "Promotions", icon: UsersThree },
  { key: "semestre", label: "Semestres", icon: CalendarBlank },
];

export default function Academic() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [type, setType] = useState("filiere");

  const load = () => api.get("/academic").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!name.trim()) return;
    try { await api.post("/academic", { name, type }); toast.success("Ajouté"); setName(""); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const del = async (id) => { await api.delete(`/academic/${id}`); load(); };

  return (
    <div className="space-y-6" data-testid="academic-page">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent">Structure</p>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Gestion académique</h1>
      </div>

      <div className="flex flex-wrap items-end gap-3 rounded-xl border border-border bg-card p-5">
        <div className="flex-1 min-w-48"><Label>Nom</Label><Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Ex: Finance" data-testid="academic-name" /></div>
        <div className="w-48">
          <Label>Type</Label>
          <Select value={type} onValueChange={setType}>
            <SelectTrigger data-testid="academic-type"><SelectValue /></SelectTrigger>
            <SelectContent>{TYPES.map((t) => <SelectItem key={t.key} value={t.key}>{t.label}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <Button onClick={add} className="bg-primary hover:bg-primary/90" data-testid="add-academic-btn"><Plus size={18} className="mr-2" /> Ajouter</Button>
      </div>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {TYPES.map((t) => (
          <div key={t.key} className="rounded-xl border border-border bg-card p-5">
            <div className="mb-3 flex items-center gap-2">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary/10 text-primary"><t.icon size={20} weight="duotone" /></div>
              <h3 className="font-display font-bold">{t.label}</h3>
            </div>
            <div className="space-y-2">
              {items.filter((i) => i.type === t.key).map((i) => (
                <div key={i.id} className="flex items-center justify-between rounded-lg bg-secondary px-3 py-2 text-sm">
                  {i.name}
                  <button onClick={() => del(i.id)}><Trash size={14} className="text-accent" /></button>
                </div>
              ))}
              {items.filter((i) => i.type === t.key).length === 0 && <p className="text-xs text-muted-foreground">Aucun élément</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
